export function formatExecutionDuration(
  startedAt: string,
  finishedAt: string | null
): string {
  if (!finishedAt) {
    return '-';
  }

  const durationMs =
    new Date(finishedAt).getTime() - new Date(startedAt).getTime();

  if (durationMs < 0) {
    return '-';
  }

  return `${durationMs}ms`;
}

export function formatExecutionTime(timestamp: string): string {
  const date = new Date(timestamp);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
}
